<section class="header-section section-spacing bg-grey">
    <div class="container">
        <div class="row mx-0 align-items-center">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <h1 class="header-title text-start mb-0">
                    <span>Infraon Assets for <br />Healthcare</span>
                </h1>
                <p class="header-desc text-start mx-0 w-100" style="margin: 24px 0">
                    Streamlining Asset Management for a Healthier Tomorrow.
                </p>

            </div>
        </div>
    </div>
</section>

<section class="container section-spacing feature-1-section">
    <div class="main-feature-wrapper section-spacing" style="background-position: top right 50px">
        <div class="feature-1-content-wrapper">
            <h2 class="section-title">What is Assets for Healthcare?</h2>
            <p class="section-paragraph">
                Assets for Healthcare is an innovative asset management solution
                specifically tailored for hospitals, nursing homes, and
                pharmaceutical companies. This comprehensive tool streamlines the
                management of medical equipment and supplies, ensuring efficient
                healthcare delivery.
            </p>
            <p class="section-paragraph mb-0">
                It integrates advanced technology to optimize asset utilization,
                reduce costs, and enhance patient care quality, making it essential
                for modern healthcare institutions.
            </p>
        </div>
        <div class="feature-1-img-wrapper"></div>
    </div>
    <div class="main-feature-wrapper section-spacing" style="background-position: top left 50px">
        <div class="feature-1-img-wrapper"></div>
        <div class="feature-1-content-wrapper">
            <h2 class="section-title">
                What does Asset Management do for Healthcare?
            </h2>
            <p class="section-paragraph">
                Infraon Assets revolutionizes healthcare asset management by
                providing a centralized system for tracking and maintaining medical
                equipment and pharmaceuticals. It offers real-time monitoring,
                predictive maintenance, and inventory control, ensuring that
                healthcare providers have the necessary tools at their disposal.
            </p>
            <p class="section-paragraph mb-0">
                This system minimizes equipment downtime, optimizes resource
                allocation, and supports compliance with healthcare standards,
                thereby improving overall service delivery.
            </p>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">
        Key Benefits of Assets for Healthcaare
    </h2>

    <div class="row mx-0 align-items-center section-spacing pt-0">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Enhanced Equipment</h3>
                <p class="section-paragraph">
                    Reliability Assets ensures that medical equipment is always
                    operational and reliable. With regular maintenance schedules and
                    predictive analytics, it reduces the likelihood of equipment
                    failures, thus guaranteeing uninterrupted patient care.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/assets-healthcare/assets-healthcare-feature-3.webp"
                class="w-100" alt="Hospital Equipments" />
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/assets-healthcare/assets-healthcare-feature-4.webp"
                class="w-90" alt="Doctors" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Cost Efficiency</h3>
                <p class="section-paragraph">
                    By optimizing asset utilization and reducing unnecessary
                    expenditures, Assets helps healthcare facilities manage their
                    finances effectively. It identifies underused resources, prevents
                    overstocking of supplies, and minimizes wastage, leading to
                    significant cost savings
                </p>
            </div>
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Regulatory Compliance</h3>
                <p class="section-paragraph">
                    Assets aids in maintaining compliance with healthcare regulations.
                    Its tracking and reporting capabilities ensure that all equipment
                    and practices meet industry standards, thus reducing the risk of
                    penalties and enhancing patient safety.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/assets-healthcare/assets-healthcare-feature-5.webp"
                class="w-100" alt="Laboratory" />
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/assets-healthcare/assets-healthcare-feature-6.webp"
                class="w-90" alt="Doctor checking the report" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Inventory Management</h3>
                <p class="section-paragraph">
                    This solution offers advanced inventory management, ensuring that
                    critical medical supplies are always available. It tracks usage
                    patterns, forecasts demand, and automates reordering processes,
                    preventing stockouts and overstock situations.
                </p>
            </div>
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Data-Driven Decisions</h3>
                <p class="section-paragraph">
                    With comprehensive analytics and reporting tools, Assets enables
                    healthcare managers to make informed decisions. It provides
                    insights into asset performance, utilization rates, and
                    maintenance needs, aiding in strategic planning and resource
                    allocation.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/assets-healthcare/assets-healthcare-feature-7.webp"
                class="w-100" alt="Doctor Checking the final report" />
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing pb-0 reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/assets-healthcare/assets-healthcare-feature-8.webp"
                class="w-90" alt="Doctors checking on the patient" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Improved Patient Care</h3>
                <p class="section-paragraph">
                    By ensuring that all medical equipment is functional and available
                    when needed, Assets contributes to higher quality patient care. It
                    streamlines workflows, reduces equipment downtime, and enhances
                    the overall efficiency of healthcare services.
                </p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing container">
    <div class="ai-based-itsm depreciation-calculator d-flex align-items-center justify-content-between primary-bg">
        <div>
            <h2 data-aos="fade-up" data-aos-delay="100" class="section-title text-start text-white">
                Introducing Our Asset <br />
                Depreciation Calculator 📉
            </h2>
            <p data-aos="fade-up" data-aos-delay="300" class="section-paragraph text-start text-white">
                Optimize your financial planning with our latest tool! <br />
                Easily calculate asset depreciation and make informed <br />
                decisions for your business.
            </p>
            <a routerLink="/free-tools/asset-depreciation-calculator/" class="text-white">
                <span>Click here to explore</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" fill="none">
                    <path
                        d="M17.2968 5.51799L12.4968 0.717991C11.562 -0.218009 10.038 -0.218009 9.10316 0.717991C8.64956 1.17039 8.39996 1.77399 8.39996 2.41479C8.39996 3.05559 8.64956 3.65919 9.10316 4.11159L12.2064 7.21479L9.10316 10.318C8.64956 10.7716 8.39996 11.374 8.39996 12.0148C8.39996 12.6556 8.64956 13.258 9.10316 13.7116C9.55676 14.1652 10.1592 14.4148 10.8 14.4148C11.4408 14.4148 12.0432 14.1652 12.4968 13.7116L17.2968 8.91159C17.7504 8.45919 18 7.85559 18 7.21479C18 6.57399 17.7504 5.97039 17.2968 5.51799ZM16.4484 8.06319L11.6484 12.8632C11.1936 13.3168 10.4064 13.3168 9.95156 12.8632C9.48356 12.3952 9.48356 11.6344 9.95156 11.1664L13.9032 7.21479L9.95156 3.26319C9.72476 3.03639 9.59996 2.73519 9.59996 2.41479C9.59996 2.09439 9.72476 1.79319 9.95156 1.56639C10.1856 1.33239 10.4928 1.21479 10.8 1.21479C11.1072 1.21479 11.4144 1.33239 11.6484 1.56519L16.4484 6.36519C16.6752 6.59319 16.8 6.89439 16.8 7.21479C16.8 7.53519 16.6752 7.83639 16.4484 8.06319Z"
                        fill="white" />
                    <path
                        d="M8.8968 5.51799L4.0968 0.717991C3.162 -0.218009 1.638 -0.218009 0.7032 0.717991C0.2496 1.17039 0 1.77399 0 2.41479C0 3.05559 0.2496 3.65919 0.7032 4.11159L3.8064 7.21479L0.7032 10.318C0.2496 10.7716 0 11.374 0 12.0148C0 12.6556 0.2496 13.258 0.7032 13.7116C1.1568 14.1652 1.7592 14.4148 2.4 14.4148C3.0408 14.4148 3.6432 14.1652 4.0968 13.7116L8.8968 8.91159C9.3504 8.45919 9.6 7.85559 9.6 7.21479C9.6 6.57399 9.3504 5.97039 8.8968 5.51799ZM8.0484 8.06319L3.2484 12.8632C2.7936 13.3168 2.0064 13.3168 1.5516 12.8632C1.0836 12.3952 1.0836 11.6344 1.5516 11.1664L5.5032 7.21479L1.5516 3.26319C1.3248 3.03639 1.2 2.73519 1.2 2.41479C1.2 2.09439 1.3248 1.79319 1.5516 1.56639C1.7856 1.33239 2.0928 1.21479 2.4 1.21479C2.7072 1.21479 3.0144 1.33239 3.2484 1.56519L8.0484 6.36519C8.2752 6.59319 8.4 6.89439 8.4 7.21479C8.4 7.53519 8.2752 7.83639 8.0484 8.06319Z"
                        fill="white" />
                </svg>
            </a>
        </div>
    </div>
</section>

<section class="container section-spacing features">
    <h2 class="section-title p-b-60 mb-0">
        Using Infraon Assets for Healthcaare
    </h2>

    <div class="row mx-0 feature-box">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="29" height="28"
                    viewBox="0 0 29 28" fill="none">
                    <path
                        d="M14.7523 0C22.4632 0 28.7523 6.28906 28.7523 14C28.7523 21.7656 22.4632 28 14.7523 28C6.98666 28 0.752289 21.7656 0.752289 14C0.752289 10.1172 2.33823 6.5625 4.90854 4.04688L6.16635 2.78906L8.62729 5.30469L7.36948 6.50781C5.45541 8.42188 4.25229 11.1016 4.25229 14C4.25229 19.7969 8.95541 24.5 14.7523 24.5C20.5492 24.5 25.2523 19.7969 25.2523 14C25.2523 8.80469 21.4242 4.48438 16.5023 3.66406V5.25V7H13.0023V5.25V1.75V0H14.7523Z"
                        fill="#084CD4" />
                    <path
                        d="M12.0414 9.42969H11.9867L16.3617 13.8047L17.2914 14.7344L15.4867 16.5938L14.557 15.6641L10.182 11.2891L9.25229 10.3594L11.1117 8.5L12.0414 9.42969Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title text-start">Real-Time Asset Tracking</h3>
                <p class="section-paragraph text-start">
                    Infraon Assets offers real-time tracking of all healthcare assets,
                    providing instant visibility into the location and status of
                    equipment, thus enhancing operational efficiency.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="29" height="29"
                    viewBox="0 0 29 29" fill="none">
                    <path
                        d="M12.5023 7.875C12.5023 3.55469 16.0023 0 20.3773 0C21.4164 0 22.4007 0.21875 23.2757 0.601562L18.6273 5.25V9.625H23.0023L27.6507 4.97656C28.0335 5.85156 28.2523 6.83594 28.2523 7.875C28.2523 11.2656 26.1195 14.1094 23.1664 15.2578L20.7054 12.7969L19.5023 11.5391L18.2445 12.7969L17.807 13.2344L12.5023 7.92969V7.875ZM0.252289 22.75L9.43979 13.5625L13.432 17.5547L12.9945 18.0469L11.7367 19.25L12.9945 20.5078L5.50229 28L0.252289 22.75ZM7.74448 22.3125L5.93979 20.5078L4.08041 22.3125L5.93979 24.1719L7.74448 22.3125Z"
                        fill="#084CD4" />
                    <path
                        d="M16.4476 18.0547L9.39291 11H6.00229L0.752289 4L4.25229 0.5L11.2523 5.75V9.19531L18.307 16.1953L20.0023 14.5L28.7523 23.25L23.5023 28.5L14.7523 19.75L16.4476 18.0547Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title text-start">Predictive Maintenance</h3>
                <p class="section-paragraph text-start">
                    Infraon Assets utilizes predictive analytics to anticipate
                    equipment maintenance needs, preventing breakdowns and extending
                    the life of healthcare assets.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="27" height="28"
                    viewBox="0 0 27 28" fill="none">
                    <path
                        d="M26.2523 7.65625C26.1976 13.125 23.9554 23.0234 14.5492 27.5625C13.6195 28 12.5804 28 11.6507 27.5625C2.24448 23.0234 0.00229412 13.125 0.00229412 7.65625C-0.0523934 6.23438 0.877294 5.08594 2.08042 4.53906L12.3617 0.164062C12.5804 0.109375 12.8539 0 13.1273 0C13.346 0 13.6195 0.109375 13.8382 0.164062L24.1195 4.53906C25.3226 5.08594 26.2523 6.23438 26.2523 7.65625ZM11.8148 3.28125L3.11948 6.94531C2.79136 7.10938 2.57261 7.38281 2.62729 7.65625C2.62729 12.4688 4.54136 20.5625 11.8148 24.6641V3.28125Z"
                        fill="#1A5AD9" />
                </svg>
                <h3 class="section-title text-start">Customizable Dashboards</h3>
                <p class="section-paragraph text-start">
                    The solution includes customizable dashboards that offer a
                    comprehensive view of asset performance, allowing healthcare
                    managers to monitor key metrics effectively.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="27" height="23"
                    viewBox="0 0 27 23" fill="none">
                    <path
                        d="M0.752289 14.625C0.752289 13.3047 1.8187 12.1875 3.18979 12.1875H9.68979C11.0101 12.1875 12.1273 13.3047 12.1273 14.625V20.3125C12.1273 21.6836 11.0101 22.75 9.68979 22.75H3.18979C1.8187 22.75 0.752289 21.6836 0.752289 20.3125V14.625ZM16.1898 0H24.3148C25.6351 0 26.7523 1.11719 26.7523 2.4375V4.0625C26.7523 5.43359 25.6351 6.5 24.3148 6.5H16.1898C14.8187 6.5 13.7523 5.43359 13.7523 4.0625V2.4375C13.7523 1.11719 14.8187 0 16.1898 0ZM13.7523 10.5625C13.7523 9.24219 14.8187 8.125 16.1898 8.125H24.3148C25.6351 8.125 26.7523 9.24219 26.7523 10.5625V12.1875C26.7523 13.5586 25.6351 14.625 24.3148 14.625H16.1898C14.8187 14.625 13.7523 13.5586 13.7523 12.1875V10.5625ZM16.1898 16.25H24.3148C25.6351 16.25 26.7523 17.3672 26.7523 18.6875V20.3125C26.7523 21.6836 25.6351 22.75 24.3148 22.75H16.1898C14.8187 22.75 13.7523 21.6836 13.7523 20.3125V18.6875C13.7523 17.3672 14.8187 16.25 16.1898 16.25Z"
                        fill="#A8C0F1" />
                    <path
                        d="M0.752289 2.5625C0.752289 1.24219 1.8187 0.125 3.18979 0.125H9.68979C11.0101 0.125 12.1273 1.24219 12.1273 2.5625V8.25C12.1273 9.62109 11.0101 10.6875 9.68979 10.6875H3.18979C1.8187 10.6875 0.752289 9.62109 0.752289 8.25V2.5625Z"
                        fill="#1A5AD9" />
                </svg>
                <h3 class="section-title text-start">
                    Automated Inventory <br />
                    Control
                </h3>
                <p class="section-paragraph text-start">
                    Infraon Assets automates inventory control processes, ensuring
                    that medical supplies are adequately stocked and available for
                    immediate use.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="29" height="27"
                    viewBox="0 0 29 27" fill="none">
                    <path
                        d="M0.752289 21.875C0.752289 21.1641 1.29916 20.5625 2.06479 20.5625H5.29135C5.83823 18.8125 7.53354 17.5 9.50229 17.5C11.4164 17.5 13.1117 18.8125 13.6585 20.5625H27.4398C28.1507 20.5625 28.7523 21.1641 28.7523 21.875C28.7523 22.6406 28.1507 23.1875 27.4398 23.1875H13.6585C13.1117 24.9922 11.4164 26.25 9.50229 26.25C7.53354 26.25 5.83823 24.9922 5.29135 23.1875H2.06479C1.29916 23.1875 0.752289 22.6406 0.752289 21.875ZM6.25229 21.625C6.25229 20.6953 10.432 21.3181 9.50229 21.3181C8.51791 21.3181 12.0721 20.9453 12.0721 21.875C12.0721 22.8594 8.51791 21.875 9.50229 21.875C10.432 21.875 6.25229 22.6094 6.25229 21.625ZM27.4398 3.0625C28.1507 3.0625 28.7523 3.66406 28.7523 4.375C28.7523 5.14062 28.1507 5.6875 27.4398 5.6875H15.4085C14.8617 7.49219 13.1664 8.75 11.2523 8.75C9.28354 8.75 7.58823 7.49219 7.04135 5.6875H2.06479C1.29916 5.6875 0.752289 5.14062 0.752289 4.375C0.752289 3.66406 1.29916 3.0625 2.06479 3.0625H7.04135C7.58823 1.3125 9.28354 0 11.2523 0C13.1664 0 14.8617 1.3125 15.4085 3.0625H27.4398ZM13.4515 4.375C13.4515 5.35938 10.1664 4.375 11.1507 4.375C12.0804 4.375 13.0023 5.35938 13.0023 4.375C13.0023 3.44531 12.0804 4.375 11.1507 4.375C10.1664 4.375 13.4515 3.44531 13.4515 4.375Z"
                        fill="#084CD4" />
                    <path
                        d="M20.0023 8.625C21.9164 8.625 23.6117 9.9375 24.1585 11.6875H27.4398C28.1507 11.6875 28.7523 12.2891 28.7523 13C28.7523 13.7656 28.1507 14.3125 27.4398 14.3125H24.1585C23.6117 16.1172 21.9164 17.375 20.0023 17.375C18.0335 17.375 16.3382 16.1172 15.7914 14.3125H2.06479C1.29916 14.3125 0.752289 13.7656 0.752289 13C0.752289 12.2891 1.29916 11.6875 2.06479 11.6875H15.7914C16.3382 9.9375 18.0335 8.625 20.0023 8.625ZM21.7523 12.625C21.7523 11.6953 23.182 12.625 22.2523 12.625C21.2679 12.625 23.7523 12.1953 23.7523 13.125C23.7523 14.1094 17.2679 12.625 18.2523 12.625C19.182 12.625 21.7523 13.6094 21.7523 12.625Z"
                        fill="#AC67F0" />
                </svg>
                <h3 class="section-title text-start">
                    Enhanced Security <br />
                    Features
                </h3>
                <p class="section-paragraph text-start">
                    Infraon Assets incorporates advanced security features to protect
                    sensitive healthcare data and ensure the confidentiality of
                    patient information.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="31.8px"
                    height="30.1px" viewBox="0 0 31.8 30.1" style="enable-background: new 0 0 31.8 30.1"
                    xml:space="preserve">
                    <g>
                        <path fill="#AB67F0"
                            d="M25.3,29.7l-1-1.1c-0.4,0.1-0.7,0.1-1.1,0.1s-0.7,0-1.1-0.1l-1,1.1C20.9,30,20.4,30.2,20,30   c-0.3-0.1-0.6-0.3-0.8-0.4l-0.3-0.2c-0.3-0.2-0.5-0.3-0.8-0.5c-0.4-0.3-0.5-0.8-0.4-1.2l0.5-1.4c-0.5-0.6-0.8-1.2-1.1-1.9l-1.5-0.3   c-0.5-0.1-0.9-0.5-0.9-0.9c-0.1-0.4-0.1-0.7-0.1-1.1c0-0.4,0-0.7,0.1-1c0.1-0.5,0.4-0.9,0.9-1l1.5-0.3c0.3-0.7,0.6-1.3,1.1-1.8   l-0.5-1.4c-0.2-0.5,0-1,0.4-1.3c0.3-0.2,0.5-0.4,0.8-0.5l0.3-0.2c0.3-0.1,0.6-0.3,0.8-0.4c0.5-0.2,1-0.1,1.3,0.3l1,1.1   c0.3-0.1,0.7-0.1,1.1-0.1c0.4,0,0.7,0,1,0.1l1-1.1c0.4-0.4,0.9-0.5,1.3-0.3c0.3,0.1,0.6,0.3,0.8,0.4l0.3,0.2   c0.3,0.2,0.5,0.4,0.8,0.5c0.4,0.3,0.5,0.8,0.4,1.3L28.3,18c0.4,0.6,0.8,1.2,1,1.8l1.5,0.4c0.5,0.1,0.8,0.5,0.9,0.9   c0.1,0.4,0.1,0.7,0.1,1.1c0,0.3-0.1,0.7-0.1,1c-0.1,0.5-0.4,0.9-0.9,0.9l-1.5,0.4c-0.2,0.7-0.6,1.3-1,1.8l0.5,1.4   c0.2,0.5,0,1-0.4,1.3c-0.3,0.2-0.5,0.3-0.8,0.5l-0.3,0.2c-0.3,0.1-0.5,0.3-0.8,0.4C26.2,30.2,25.7,30,25.3,29.7z M23.3,24.6   c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.4,0-2.4,1.1-2.4,2.4C20.9,23.5,21.9,24.6,23.3,24.6z" />
                        <path fill="#084CD4"
                            d="M15.5,6.5l-1.1,1c0.1,0.4,0.1,0.7,0.1,1.1c0,0.4,0,0.7-0.1,1.1l1.1,1c0.4,0.3,0.5,0.8,0.3,1.3   c-0.1,0.3-0.3,0.6-0.4,0.8l-0.2,0.3c-0.2,0.3-0.3,0.5-0.5,0.8c-0.3,0.4-0.8,0.5-1.3,0.4l-1.4-0.5c-0.6,0.5-1.2,0.8-1.9,1.1   l-0.3,1.5C9.8,16.6,9.4,17,9,17c-0.4,0.1-0.7,0.1-1.1,0.1c-0.3,0-0.7,0-1-0.1C6.4,17,6,16.6,6,16.1l-0.4-1.5   C5,14.4,4.4,14,3.8,13.6l-1.4,0.5c-0.5,0.2-1,0-1.3-0.4c-0.2-0.3-0.4-0.5-0.5-0.8l-0.2-0.3c-0.1-0.3-0.3-0.6-0.4-0.8   c-0.2-0.5-0.1-1,0.3-1.3l1.1-1C1.5,9.3,1.5,8.9,1.5,8.5c0-0.4,0-0.7,0.1-1l-1.1-1C0,6.1-0.1,5.7,0.1,5.2c0.1-0.3,0.3-0.6,0.4-0.8   l0.2-0.3C0.8,3.9,1,3.7,1.1,3.4C1.4,3,1.9,2.9,2.4,3l1.4,0.5c0.6-0.4,1.2-0.8,1.9-1L6,1c0.1-0.5,0.5-0.8,0.9-0.9C7.3,0.1,7.6,0,8,0   c0.3,0,0.7,0.1,1,0.1c0.5,0.1,0.9,0.4,1,0.9l0.3,1.5c0.7,0.2,1.3,0.6,1.8,1L13.5,3c0.5-0.2,1,0,1.3,0.4c0.2,0.3,0.4,0.5,0.5,0.8   l0.2,0.3c0.1,0.3,0.3,0.5,0.4,0.8C16,5.7,15.8,6.1,15.5,6.5z M10.4,8.5c0-1.3-1.1-2.4-2.4-2.4c-1.4,0-2.4,1.1-2.4,2.4   C5.5,9.9,6.6,11,8,11C9.3,11,10.4,9.9,10.4,8.5z" />
                    </g>
                </svg>
                <h3 class="section-title text-start">
                    Integrated Compliance <br />
                    Management
                </h3>
                <p class="section-paragraph text-start">
                    Assets integrates compliance management tools, making it easier
                    for healthcare institutions to adhere to industry regulations and
                    standards.
                </p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation
                    (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our
                    customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing primary-bg trial-now">
    <div class="container">
        <h2 class="section-title text-center text-white"><span class="text-lowercase">How about a free trial with NO
                credit card required?</span></h2>

        <div class="primary-buttons cta-buttons rounded-l">
            <a routerLink="/it-asset-management/prices/assets-pricing" style="background-color: transparent;color: var(--title);">Start now</a>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/it-assets-management-solutions">
                <div class="backlink-wrapper">
                    <div class="backlink-thumbnail-wrapper">
                        <img src="/assets/img/feature-pages/infraon-assets/it-services-solution/itam-thumbnail-01.webp"
                            class="w-100 backlink-thumbnail" alt="IT Asset Management Thumbnail" />
                    </div>
                    <div class="backlink-container bg-white">
                        <p class="section-title-s text-start">IT Asset Management</p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
            <a
                routerLink="/it-asset-management/features/software-assets-management-solutions">
                <div class="backlink-wrapper">
                    <div class="backlink-thumbnail-wrapper">
                        <img src="/assets/img/feature-pages/infraon-assets/it-services-solution/sam-thumbnail-01.webp"
                            class="w-100 backlink-thumbnail" alt="Software Asset Management Thumbnail" />
                    </div>
                    <div class="backlink-container bg-white">
                        <p class="section-title-s text-start">
                            Software Asset Management
                        </p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
            <a routerLink="/itsm-tool">
                <div class="backlink-wrapper">
                    <div class="backlink-thumbnail-wrapper">
                        <img src="/assets/img/feature-pages/infraon-assets/assets-healthcare/itsm-thumbnail-01.webp"
                            class="w-100 backlink-thumbnail" alt="IT Service Management Thumbnail" />
                    </div>
                    <div class="backlink-container bg-white">
                        <p class="section-title-s text-start">IT Service Management</p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </div>
            </a>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>